export function makePromisePack() {
    var po = {};
    po.promise = new Promise(function (resolve, reject) {
        po.resolve = resolve;
        po.reject = reject;
    });
    return po;
}
